import React, { useEffect, useState } from "react";
import Configuration from "../../configuration";
import { useTranslation } from 'react-multi-lang';

const DownloadFileCell = ({ nom_file }) => {
    const t = useTranslation();
    const [fileExists, setFileExists] = useState(null);
    const fileUrl = Configuration.BACK_BASEURL + "extraction/" + nom_file;
    
    useEffect(() => {
        let cancelled = false;

        fetch(fileUrl, { method: 'HEAD' })
            .then((res) => {
                if (!cancelled) setFileExists(res.ok);
            })
            .catch(() => {
                if (!cancelled) setFileExists(false);
            });

        return () => {
            cancelled = true;
        };
    }, [fileUrl]);

    if (fileExists === null) {
        return <span className="text-muted">{t("checking")}</span>;
    }

    if (!fileExists) {
        return null; // ou return <span className="text-danger">Fichier introuvable</span>
    }

    return (
        <a
            className="btn btn-info"
            download={nom_file}
            rel="noreferrer"
            href={fileUrl}
            target="_blank"
        >
            <i className="fas fa-download"></i> {t("download")}
        </a>
    );
};

export default DownloadFileCell;
